import { ItemListContent, EmptyView } from "@eusoft/webapp-framework";
import { content, formatText, MaterialIcon } from "@eusoft/webapp-ui";
import { type IListMerchantServices, type IMerchantServiceView } from "../../entities/Commands";
import { entityItemsSource } from "../../helpers/ItemsSources";
import { context } from "../../services/Context";
import { WithContext } from "../../services/WithContext";
import { EditMerchantServicePage } from "./EditMerchantServicePage";

export interface IListMerchantServicesArgs {

}


export const ListMerchantServicesPage = ItemListContent.builder<IMerchantServiceView, IListMerchantServices>()

    .info({
        name: "merchant-services",
        route: "/merchant/services",
        icon: <MaterialIcon name="api" />
    })

    .feature(WithContext("merchant"))

    .options(() => ({

        canAdd: true,
        canEdit: true,
        title: "merchant-services",
        style: ["panel", "round-item"],
        confirmDeleteMessage: "msg-confirm-delete",
        itemsSource: entityItemsSource("ListMerchantServices", false),
        itemAddContent: () => content(EditMerchantServicePage.info,
        {
            merchantId: context?.merchant?.id,
        }),
        itemEditContent: item => content(EditMerchantServicePage.info,
        {
            value: item,
            serviceName: item?.providerName,
            merchantId: context?.merchant?.id,
        }),
        //deleteItemAsync: deleteSalePointAsync,
        pageSize: 50,
        addLabel: formatText("connect-new"),
        prepareFilter: (curFilter, offset, limit) => ({
            merchantId: context?.merchant?.id,
            ...curFilter,
        }),
        emptyView: <EmptyView
            iconName="api"
            message="msg-no-service-found"
        />,
        columns: [{
            value: a => a.name,
            priority: "primary",
            header: "name",
        }],
        editMode: "page"

    })).asContent();
